import React from 'react'
import styled from 'react-emotion'
import Button from 'common/components/Button'
import { z } from '../../../style'
import { useTranslation } from 'react-i18next'

const ActivityIcon = styled(({ unread, active, toggleActivity, className }) => {
  const { t } = useTranslation()
  return (
    <Button
      className={className}
      primary={active}
      danger={unread > 0}
      onClick={toggleActivity}
      tooltip={t('sidebar.tooltips.activity')}
    >
      {unread}
    </Button>
  )
})({
  label: 'ActivityIcon',
  zIndex: z.activityButton
})

export default ActivityIcon
